import * as SpotCheck from '../schemas/permits/spotCheck.json'

export default {
    type: 'Permit Spot Check',
    schemas: {
        'Spot Check': SpotCheck,
    }
}